<template>
  <div class="collect-consent">
    <el-row>
      <el-col :span="13">
      </el-col>
      <el-col :span="mainWithValue">
        <div class="grid-content"
          style="margin: 30px 0px;">

          <CCUserLogOverview :textLoaded="textLoaded" :fileLogData="fileLogData" />

          <CCTextPlaceholder :textLoaded="textLoaded"/>

          <json-editor
            v-if="textLoaded"
            :schema="schema"
            :locale="jsonEditorConf"
            :initial-value="propertiesInitialValue"
            @update-value="updateValue($event)"
            :minItemCountIfNeedFilter="9999999"
            theme="element-ui2"
            icon="element-ui2">
          </json-editor>

        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="Editor"
      :visible.sync="showEditor"
      :append-to-body="true"
      width="75%"
      custom-class="toolbar-editor-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center>
        <el-container v-if="showEditor">

          <CCEditor @editorMounted="editorMounted" />

        </el-container>

        <span slot="footer" class="dialog-footer">
          <span v-if="!inputElemInprogress" class="message">
            You need to choose an input field to work with
          </span><br>
          <el-button @click="toggleEditor">Cancel</el-button>
          <el-button type="primary" @click="copyBackToInputField">Confirm</el-button>
      </span>
    </el-dialog>

    <CCPreview
      :choosenCountry="choosenCountry"
      :choosenLanguage="choosenLanguage"
      :textFile="textFile"
      :showPreview="showPreview"
      :valueHtml="valueHtml"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { Notification } from 'element-ui';
import { mapGetters } from 'vuex';
import CCEditor from '@/components/CollectConsent/TextEditor.vue';
import CCPreview from '@/components/CollectConsent/CCPreview.vue';
import CCUserLogOverview from '@/components/CollectConsent/CCUserLogOverview.vue';
import CCTextPlaceholder from '@/components/CollectConsent/CCTextPlaceholder.vue';
import 'vue-schema-based-json-editor';
import '@/views/CollectConsent/CollectConsent.scss';
import schema from '../../schema/collectConsentSchema.json';
import jsonEditorConfiguration from '../../schema/localeconfig';
import Firebase from '../../fireBaseInit';

export default {
  components: {
    CCEditor,
    CCPreview,
    CCUserLogOverview,
    CCTextPlaceholder,
  },
  computed: {
    ...mapGetters([
      'textFile',
      'choosenLanguage',
      'choosenCountry',
      'receivedDropDownValue',
    ]),
    // mapGetters can only be used for getting values from store
    // to be able to set values in this component whit this."value" = "something"
    // we need to specify a setter as well to update te store
    // And therefore we need to specifically write a getter
    showPreview: {
      get() {
        return this.$store.getters.showPreview;
      },
      set() {
        this.$store.commit('openTextPreview', false);
      },
    },
    refreshText: {
      get() {
        return this.$store.getters.refreshText;
      },
      set() {
        this.$store.commit('freshTextFile', false);
      },
    },
    showEditor: {
      get() {
        return this.$store.getters.showEditor;
      },
      set(value) {
        this.$store.commit('openEditor', value);
      },
    },
    uploadText: {
      get() {
        return this.$store.getters.uploadText;
      },
      set() {
        this.$store.commit('signalTextUpload', false);
      },
    },
    jsonEditorConf() {
      // `this` points to the vm instance
      return this.jsonEditorConfiguration.jsonEditorConf;
    },
  },
  created() {
    // get user from store
    this.user = this.$store.state.user.userData;
  },
  updated() {
    // We need to set an ID on input and textArea fields as we want to be able to determine
    // in which inputfield the user is currently working
    // the json editor does not provide an option to do this automaticaly
    // Also it does not provide for setting event listeners in a vue like way..
    // so here's some more JS!! :D
    // We can also call this Area: "Hack the JSON editor"

    // hack: add event to ask user a confirmation before deleting
    const inputElements = document.getElementsByClassName('schema-based-json-editor--input');
    const numberOfInputElements = inputElements.length;

    for (let i = 0; i < numberOfInputElements; i += 1) {
      inputElements[i].setAttribute('id', `input-${i}`);
      inputElements[i].addEventListener('click', this.getCursorPosition);
      inputElements[i].addEventListener('input', this.getCursorPosition);
    }

    const textAreaElements = document.getElementsByClassName('schema-based-json-editor--textarea');
    const numberOfTextAreaElements = textAreaElements.length;

    for (let i = 0; i < numberOfTextAreaElements; i += 1) {
      textAreaElements[i].setAttribute('id', `textArea-${i}`);
      textAreaElements[i].addEventListener('click', this.getCursorPosition);
      textAreaElements[i].addEventListener('input', this.getCursorPosition);
    }

    // hack: every segment field has a search field, this needs to be gone!
    const isSearchField = document.querySelectorAll('[placeholder="search"]');
    if (isSearchField.length) {
      for (let i = 0; i < isSearchField.length; i += 1) {
        isSearchField[i].parentElement.setAttribute('style', 'display:none;');
      }
    }

    // hack: Some properties are read only (defined in the schema)
    // these have not to be shown.
    const isReadOnly = document.querySelectorAll('[readonly=true]');
    if (isReadOnly.length) {
      for (let i = 0; i < isReadOnly.length; i += 1) {
        isReadOnly[i].parentElement.setAttribute('style', 'display:none;');
      }
    }

    // hack for showing segment titles and their checkboxes.
    // this overrides to only showing "Index"
    const segmentTitles = document.querySelectorAll('.schema-based-json-editor--title');
    if (segmentTitles.length) {
      for (let i = 0; i < segmentTitles.length; i += 1) {
        const label = segmentTitles[i].closest('label').innerText;
        if (label.match('index')) {
          segmentTitles[i].innerHTML = 'Index';
        }
      }
    }

    // hack: add event to ask user a confirmation before deleting
    const isChecked = document.querySelectorAll("input[type='checkbox']");
    if (isChecked.length) {
      for (let i = 0; i < isChecked.length; i += 1) {
        isChecked[i].addEventListener('click', this.checkRemoval);
      }
    }

    // hack: add event to ask user a confirmation before deleting
    const buttonGroup = document.querySelectorAll('.schema-based-json-editor--button-group');
    if (buttonGroup.length) {
      for (let i = 0; i < buttonGroup.length; i += 1) {
        const findRemoveButton = buttonGroup[i].lastChild.childNodes;

        if (findRemoveButton.length) {
          if (findRemoveButton[0].classList.contains('el-icon-close')) {
            buttonGroup[i].lastChild.childNodes[0].addEventListener('click', this.checkSegmentRemoval);
          }
        }
      }
    }
    // hack: Override default values of schema
    this.schema.title = this.propertiesInitialValue.key;
  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.$confirm('Do you really want to leave? Unsaved changes will be lost.', 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      type: 'warning',
    }).then(() => {
      this.$store.commit('isTextLoaded', false);
      this.textLoaded = false;
      this.mainWithValue = 24;
      this.showEditor = false;
      this.showToolbar = false;
      next();
    }).catch(() => {
      // else prevent the browser from navigating away
      next(false);
    });
  },
  name: 'CollectConsent',
  data() {
    return {
      cursorData: {
        currentElementId: '',
        currentPosition: 0,
      },
      jsonEditorConfiguration,
      textLoaded: false,
      uploadPercentage: 0,
      propertiesInitialValue: {},
      schema,
      valueHtml: '',
      user: '',
      fileLogData: [],
      mainWithValue: 24,
      inputElemInprogress: '',
    };
  },
  methods: {
    checkSegmentRemoval(e) {
      const remove = window.confirm('Do you really want to remove this item?'); // eslint-disable-line
      if (!remove) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    checkRemoval(event) {
      const removing = event.srcElement.checked;
      let remove = Boolean;

      if (removing) {
        remove = window.confirm('Do you really want to remove this item?');  // eslint-disable-line
      }

      if (!remove) {
        event.preventDefault();
      }
    },
    editorMounted() {
      const { cursorData } = this;
      const editorInputId = 'input-editor';
      const editorInputElem = document.getElementById(editorInputId);
      editorInputElem.addEventListener('click', this.getCursorPosition);
      editorInputElem.addEventListener('input', this.getCursorPosition);

      if (cursorData.currentElementId !== '') {
        const elemId = cursorData.currentElementId;
        const inputElem = document.getElementById(elemId);
        this.inputElemInprogress = inputElem;
        const inputValue = inputElem.value;
        editorInputElem.innerHTML = inputValue;
      }
    },
    toggleEditor() {
      this.showEditor = !this.showEditor;
      this.$store.commit('openEditor', this.showEditor);
    },
    copyBackToInputField() {
      const editorInputId = 'input-editor';
      const editorInputElem = document.getElementById(editorInputId);
      this.triggerEvent(editorInputElem, 'input');


      const editorOutputId = 'html-output';
      const editorOutPutElem = document.getElementById(editorOutputId);
      let editorOutPutValue = editorOutPutElem.innerText;
      editorOutPutValue = editorOutPutValue.replace(/&nbsp;/g, '');

      if (editorOutPutValue !== undefined && editorOutPutValue !== '') {
        const selectedInputElem = this.inputElemInprogress;
        selectedInputElem.value = editorOutPutValue;
        this.triggerEvent(selectedInputElem, 'change');
      }
      this.toggleEditor();
    },
    getUserLogs() {
      const { textFile } = this;
      const country = this.choosenCountry;
      const language = this.choosenLanguage;
      const THIS = this; // this Vue component

      // get firestore userLogsCC
      Firebase.fireStoreDB.collection('userLogsCC').orderBy('timestamp', 'desc').limit(20).get()
        .then((querySnapshot) => {
          const userLogs = [];
          querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
            if (
              doc.data().file === textFile
              && doc.data().language === language
              && doc.data().country === country
            ) {
              const timeInSeconds = doc.data().timestamp.seconds;
              const newEpoch = new Date(timeInSeconds * 1000);

              const { userId } = doc.data();
              const { userName } = doc.data();
              const dateTime = newEpoch.toLocaleString();

              userLogs.push({
                userId,
                userName,
                dateTime,
              });
            } else {
            // the requeested file is not updated before
            }
            THIS.fileLogData = userLogs;
          });
        });
    },
    getText() {
      if (this.textFile === '') {
        return;
      }

      this.getUserLogs();
      // set textLoaded to false to begin with, set it to true to end with
      // and you have a non-reactive component (vue-json-editor) becomming reactive!
      this.textLoaded = false;
      const storageRef = Firebase.storage.ref();
      storageRef.child(`collectconsent/cc-texts/${this.choosenCountry}/${this.textFile}.${this.choosenLanguage}.json`).getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          Notification({
            title: 'Info',
            message: `${response.data.key} successfully loaded.`,
            type: 'info',
          });
          this.propertiesInitialValue = response.data;
          this.updateValue(response.data);
          // this.startEditor()
          this.textLoaded = true;
          this.$store.commit('isTextLoaded', this.textLoaded);
          this.refreshText = false;
        }).catch((error) => {
          Notification({
            title: 'Warning',
            message: error.message,
            type: 'warning',
          });
        });
      }).catch((error) => {
        Notification({
          title: 'Warning',
          message: error.message,
          type: 'warning',
        });
      });
    },
    updateUserLogs() {
      const timeStamp = new Date();
      Firebase.fireStoreDB.collection('userLogsCC').add({
        userId: this.user.uid,
        userName: this.user.displayName,
        email: this.user.email,
        timestamp: timeStamp,
        file: this.textFile,
        language: this.choosenLanguage,
        country: this.choosenCountry,
      }).then(() => {
        this.getUserLogs();
      }).catch((error) => {
        console.error('Error adding document: ', error);
        Notification({
          title: 'Upload Completed',
          message: `Error adding document: ${error}`,
          type: 'success',
        });
      });
    },
    checkAndOrderSegments() {
      const { segments } = this.propertiesInitialValue;
      const dupliCheck = [];
      const dupliCheckResults = [];
      const OrderedSegments = [];

      // fill the dupliCheck array with all user specified indexnumbers
      Object.keys(segments).forEach((item) => {
        dupliCheck.push(Number(segments[item].index));
      });

      // sort all indexnumber in order
      dupliCheck.sort();

      // loop over the arra
      for (let i = 0; i < segments.length - 1; i += 1) {
        // if the next number equels the current number
        // then push it to the dupliCheckResults
        if (dupliCheck[i + 1] === dupliCheck[i]) {
          dupliCheckResults.push(dupliCheck[i]);
        }
      }

      // If there are no dupliCheckresults
      // Then order the segments on the user specified index number
      if (dupliCheckResults.length === 0) {
        Object.keys(segments).forEach((item) => { // eslint-disable-line
          // first create an index number for the array
          const indexNum = (Number(segments[item].index) - 1);
          // then set the segment item on the array with a predefined index number
          OrderedSegments[indexNum] = segments[item];
        });
      } else {
        // else notify the user that he has multiple indexes spacified with the same number
        Notification({
          type: 'warning',
          message: `File NOT saved. Index duplication: ${dupliCheckResults}.`,
        });
        return false;
      }

      return OrderedSegments.filter(String);
    },
    uploadNewText() {
      this.$confirm('This will overwrite the existing file. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        // We might need to reorder the segment items...
        // const OrderedSegments = this.checkAndOrderSegments();

        // // set the segments array to the new aray
        // // but first filter for Strings, because maybe index numbers don't add up
        // // if so empty array values where created and this filter removes them.
        // if (OrderedSegments !== false) {
        //   this.propertiesInitialValue.segments = OrderedSegments;
        // }

        const storageRef = Firebase.storage.ref();
        const data = JSON.stringify(this.propertiesInitialValue).replace(/\\n/g, '<br>');
        const blob = new Blob([data], { type: 'application/json' });
        const metadata = {
          contentType: 'application/json',
        };
        const uploadTask = storageRef.child(`collectconsent/cc-texts/${this.choosenCountry}/${this.textFile}.${this.choosenLanguage}.json`).put(blob, metadata);
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(
          'state_changed', // or 'state_changed'
          (snapshot) => {
          // Get task progress
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.uploadPercentage = progress;
            console.log(`Upload is ${progress}% done`);
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log('Upload is paused');
                break;
              case 'running': // or 'running'
                console.log('Upload is running');
                break;
              default:
                console.log('No task state available');
            }
          }, (error) => {
            Notification({
              title: 'Warning',
              message: error.message,
              type: 'warning',
            });
          }, () => {
            // Upload completed successfully
            this.updateUserLogs();
            Notification({
              title: 'Upload Completed',
              type: 'success',
            });
          },
        );
      }).catch((error) => {
        Notification({
          type: 'info',
          message: error,
        });
      });
      this.$store.commit('signalTextUpload', false);
    },
    triggerEvent(el, type) {
      // this function is JS equivalent to JQ's .trigger method
      if ('createEvent' in document) {
        // modern browsers, IE9+
        const e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
      } else {
        // IE 8
        const e = document.createEventObject();
        e.eventType = type;
        el.fireEvent(`on${e.eventType}`, e);
      }
    },
    // When not in editing mode the user can place variables from the variables dropdown
    // directly into the input area at cursor position
    pasteAtCursorPosition() {
      if (this.cursorData !== undefined) {
        const addText = this.dropDownValue;
        const inputElement = document.getElementById(this.cursorData.currentElementId);
        const currentCursorPosition = this.cursorData.currentPosition;

        // make sure the user has actually clicked in an input area first
        if (inputElement !== null) {
          inputElement.focus();
          const originalText = inputElement.value;
          const originalTextLengt = originalText.length;

          if (originalTextLengt === currentCursorPosition && originalText !== 'undefined') {
            inputElement.value += addText;

            // this adds the length of the text to the previous cursor position
            // else user is not able to paste multiple variables after each other
            this.cursorData.currentPosition = currentCursorPosition + addText.length;
            // trigger change so input values get updated
            this.triggerEvent(inputElement, 'change');
          } else {
            const textStart = originalText.substring(0, currentCursorPosition);
            const textEnd = originalText.substring(currentCursorPosition, originalTextLengt);

            if (inputElement.value !== 'undefined') {
              inputElement.value = textStart + addText + textEnd;
            }
            // trigger change so input values get updated
            this.triggerEvent(inputElement, 'change');
          }
        } else {
          this.$message({
            message: 'You did not yet select an input field',
            type: 'warning',
          });
        }
      }
    },
    updateValue(value) {
      this.valueHtml = value;
    },
    getCursorPosition(event) {
      // On input or click get and set input element id and cursor position
      if (typeof event.target.selectionStart !== 'undefined') {
        this.cursorData = {
          currentElementId: event.target.id,
          currentPosition: event.target.selectionStart,
          positionEnd: event.target.selectionEnd,
        };
      } else {
        this.cursorData = undefined;
      }
    },
  },
  // watch for prop changes
  watch: {
    textFile() {
      this.getText();
    },
    choosenLanguage() {
      this.getText();
    },
    choosenCountry() {
      this.getText();
    },
    receivedDropDownValue(newValue) {
      this.dropDownValue = newValue;
      this.pasteAtCursorPosition();
    },
    refreshText(newValue) {
      if (newValue) {
        this.getText();
      }
    },
    uploadText(newValue) {
      if (newValue) {
        this.uploadNewText();
      }
    },
  },
};
</script>
